import AwosMessage from './AwosMessage';

export default AwosMessage;


/** WEBPACK FOOTER **
 ** ./src/AwosMessage/index.js
 **/